export default __webpack_public_path__ + "static/63059049-fd8b22e95fca7f740285c1736abdb1f8.jpg";